import { setLoading } from 'state/reducers/requests.reducers';
import API from 'services/api.services';
import { store } from 'state/store';
import { API_GET_NOTIFICATIONS, API_UPDATE_NOTIFICATIONS } from 'constants/db.constants';
import { setCompanyNotifications } from 'state/reducers/notifications.reducer';

export function getNotificationsByCompanyId(companyId: number) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		const paramsSetting = {
			companyId,
		};
		await API.getInstance()
			.get(API_GET_NOTIFICATIONS, paramsSetting)
			.then((response) => {
				dispatch(setCompanyNotifications(response.data.notifications));
				dispatch(setLoading(false));
			})
			.catch((error) => {
				dispatch(setLoading(false));
			});
	};
}

export function updateNotificationsByCompanyId(notifications: number[]) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		const paramsSetting = {
			companyId: store.getState().user.details?.companyId,
			notifications,
		};
		await API.getInstance()
			.post(API_UPDATE_NOTIFICATIONS, paramsSetting)
			.then((response) => {
				dispatch(setCompanyNotifications(response.data.notifications));
				dispatch(setLoading(false));
			})
			.catch((error) => {
				dispatch(setLoading(false));
			});
	};
}
